import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RequestRoleResponse } from "@/types";
import { httpRequest } from "@/lib";

export type UpdateRoleRequestDTO = {
  id: string;
  name: string;
};

async function updateRole(
  request: UpdateRoleRequestDTO
): Promise<RequestRoleResponse> {
  const { id, ...updateData } = request;

  const response = await httpRequest.put<RequestRoleResponse>(
    `/positions/${id}`,
    updateData
  );
  return response.data;
}

export function useUpdateRoleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["positions"] });
    },
  });
}
